import React from 'react';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import {
  IWithWorksheetInjectedProps,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
  WorksheetAssociatedTestSection,
} from '../../../../Core';
import { Field, NumericInput, Checkbox } from '../../../../../Core';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { SectionGroup } from 'Components/Layout';

let LiquidLimitMethodBTrialSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t) => ({
        dim: t.ExcludedTrial,
      }))
    ),
    deepEquals
  );

  return (
    <SectionGroup>
      <WorksheetGridFieldSection name="Trials">
        <WorksheetRecordGrid
          name={'Trials'}
          orientation={'horizontal'}
          recordProps={{
            width: 130,
            dim: (i) => trialRecordProps[i]?.dim,
            enforceAtLeastOneRecord: true,
            removeConfirm: {
              confirm: true,
              confirmTitle: 'Trial Deletion',
              confirmText: 'Are you sure you want to delete the selected trial?',
              confirmButtonText: 'Delete Trial',
            },
          }}
          fieldSet={[
            {
              name: 'Drops',
              component: <Field input={<NumericInput />} />,
              label: 'Drops', // Remove when labels migrated to config
            },
            {
              name: 'ExcludedTrial',
              component: <Field input={<Checkbox />} />,
              label: 'Exclude Trial', // Remove when labels migrated to config
            },
          ]}
        />
      </WorksheetGridFieldSection>
      <WorksheetAssociatedTestSection
        heading="AASHTO T 265 Moisture Content"
        name="EmbeddedWaterContent"
        testType="Moisture Content"
        associatedTestModel={{
          measured: true,
        }}
      />
    </SectionGroup>
  );
};

LiquidLimitMethodBTrialSection = withInjectedProps(LiquidLimitMethodBTrialSection);

export { LiquidLimitMethodBTrialSection };
export default LiquidLimitMethodBTrialSection;
